import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import section4 from "../assets/img/section-4.png";

const HeroSection = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "579px",
        backgroundImage: `url(${section4})`,
        backgroundSize: "cover",
        backgroundPosition: "50% 50%",
        display: "flex",
      }}
    >
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          width: { xs: "100%", md: "55%" },
          height: "100%",
          bgcolor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Container>
          <Typography
            variant="subtitle1"
            color="#89888c"
            sx={{
              fontFamily: "'Inter-Regular', Helvetica",
              fontSize: "17px",
              lineHeight: "20.4px",
              mb: 2,
            }}
          >
            IT Solutions
          </Typography>

          <Typography
            variant="h4"
            color="#313032"
            sx={{
              fontFamily: "'Outfit-SemiBold', Helvetica",
              fontWeight: 600,
              fontSize: "2.25rem",
              lineHeight: "46px",
              mb: 3,
              maxWidth: "524px",
            }}
          >
            Streamlined Remote IT Support For Modern Businesses
          </Typography>

          <Typography
            variant="body1"
            color="#727074"
            sx={{
              fontFamily: "'Inter-Regular', Helvetica",
              fontSize: "16px",
              lineHeight: "25.3px",
              mb: 5,
              maxWidth: "518px",
            }}
          >
            Our team of certified IT professionals delivers comprehensive remote support for your business technology needs. We handle everything from routine maintenance to complex troubleshooting, ensuring your systems run smoothly without requiring on-site visits.
          </Typography>

          {/* <Button
            variant="outlined"
            sx={{
              fontFamily: "'Inter-Regular', Helvetica",
              color: "#9f9c9f",
              borderColor: "#9f9c9f",
              borderRadius: "10px",
              textTransform: "none",
              padding: "10px 20px",
              minWidth: "149px",
              height: "47px",
            }}
          >
            Learn More
          </Button> */}
        </Container>
      </Box>
    </Box>
  );
};

export default HeroSection;